import { get } from "../../utils/object-helpers";

<if(state.hasModule)>
    <div class="str-search-wrap" key="str-search-wrap">
        <form class="str-search" on-submit("onSubmit") data-testid="search-bar">
            <ebay-search-24-icon class=state.iconClass/>
            <label for=state.searchId class="ui-helper-hidden-accessible">${state.accesibilityText}</label>
            <input id=state.searchId key=state.searchId name="_bkw" class=`str-search__input ${state.inputClass}` value=state.keyword
                placeholder=state.placeHolderText autocomplete="off" role="combobox" aria-label=state.placeHolderText
                aria-autocomplete="list" autocorrect="off" autocapitalize="off" spellcheck="false"
                aria-expanded=(state.suggestionListClassOpen ? "true" : "false")
                aria-activedescendant=(state.activeSuggestion?.id ? `ui-sr-id-${state.activeSuggestion?.id}` : '')
                aria-owns="ui-sr" aria-controls="ui-sr"
                on-input("handleInput") on-focus("handleFocus")
                on-blur("handleBlur") on-keydown("handleInputNav") />
            <span role="status" aria-live="polite" class="ui-helper-hidden-accessible">
                ${state.announceSuggestionsText}
            </span>                        
            <if(state.suggestionListClassOpen)>
                <ul
                    role="listbox"
                    id="ui-sr"
                    class=`str-search__suggestions ${state.suggestionListClassOpen}`
                    on-mouseup("handleSuggestListSelect")>
                    <for|suggestion| of=state.suggestions>
                        <li value=suggestion.text tabindex="-1" aria-label=suggestion.text
                            id=`ui-sr-id-${suggestion.id}`
                            class=(suggestion.active && ".active")
                            aria-selected=(suggestion.active && "true")
                            role="option" on-keydown("handleResultsNav") on-focus("toggleActive") >
                            ${suggestion.text}
                        </li>
                    </for>
                </ul>
            </if>
        </form>
    </div>
</if>
